function Footer({ footer }) {
  const handleSocialClick = (url) => {
    if (!url) {
      alert('Ссылка будет добавлена позже');
      return;
    }

    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <footer id="contacts" className="landing-footer" aria-label="Footer">
      <div className="container footer-inner">
        <div>
          <h3>Stay Connected</h3>
          <p>Contact: {footer.contactEmail}</p>
        </div>

        <div className="socials" aria-label="Social links placeholders">
          {footer.socials.map((social) => (
            <button
              key={social.name}
              type="button"
              className="social-link"
              onClick={() => handleSocialClick(social.url)}
              aria-label={`Open ${social.name}`}
            >
              {social.name}
            </button>
          ))}
        </div>

        <p className="copyright">{footer.copyright}</p>
      </div>
    </footer>
  );
}

export default Footer;
